/* eslint-disable prefer-template */
/* eslint-disable no-multi-assign */
/* eslint-disable one-var */
/* eslint-disable no-bitwise */
/* eslint-disable max-len */
/* eslint-disable eqeqeq */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-properties */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-cond-assign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-nested-ternary */
import dayjs from 'dayjs';
import React from 'react';
import { MD5, enc } from 'crypto-js';
import Quill from './quill-configs';
import { randomArrayItem } from './array.utils';

// @ts-ignore
export const localRandomUuid: string = window.crypto.randomUUID();

/**
 * Converts the input string to Snake Case
 * ex:
 * input : 'User Good'
 * output : 'user_good'
 * @param {string} string
 * @returns {string}
 */
export const convertToSnakeCase = (string: string): string => {
  if (!string) {
    return '';
  }
  return string
    .replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map((word) => word.toLowerCase())
    .join('_');
};

export const convertSnakeCaseToTitleCase = (string: string, capitalize: 'first-letter' | boolean = true): string => {
  if (!string) {
    return '';
  }

  const text = string.replace(/_/g, ' ');

  if (!capitalize) {
    return text;
  }

  if (capitalize === 'first-letter') {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  return text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Converts the input number with commas
 * ex:
 * input : '12232'
 * output : '12,232'
 * @param {number} x
 * @returns {string}
 */
export const numberWithCommas = (x: any): string => x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

/**
 * coverts number to US Dollar
 * ex:
 * input : '12232'
 * output : '12,232'
 * @param {number} x
 * @returns {string}
 */
export const priceFormatter = (x: any): string => {
  return x || x === 0 || x === '0' ? `$${numberWithCommas(Number.parseFloat(`${x}`)?.toFixed(2))}` : x;
};

/**
 * Returns the appropriate color for the given status
 * @param {string} status
 * @returns {string}
 */
export const getStatusColor = (status: string): string => {
  const greenStatus = [
    'completed',
    'online',
    'success',
    'paid',
    'processed',
    'sent',
    'active',
    'published',
    'succeeded',
    'request',
  ];

  const yellowStatus = ['approved', 'draft'];
  const redStatus = ['needs_attention', 'failed', 'fail', 'high'];
  const purpleStatus = ['todo'];
  const cyanStatus = ['in_progress', 'scheduled'];
  const magentaStatus = ['waiting_approval', 'waiting_to_launch'];
  const goldStatus = ['pending', 'paused', 'to_review', 'medium'];
  const greyStatus = ['cancelled', 'inactive', 'deleted'];

  let color = 'blue';

  if (greyStatus.includes(status)) color = 'grey';
  if (purpleStatus.includes(status)) color = 'purple';
  if (cyanStatus.includes(status)) color = 'cyan';
  if (magentaStatus.includes(status)) color = 'magenta';
  if (goldStatus.includes(status)) color = 'gold';
  if (greenStatus.includes(status)) color = 'green';
  if (yellowStatus.includes(status)) color = 'yellow';
  else if (redStatus.includes(status)) color = 'red';

  return color;
};

export const getAntdColorHex = (color: string) => {
  const colorMap: any = {
    magenta: '#ffadd2',
    blue: '#91caff',
    grey: '#808080',
    purple: '#d3adf7',
    cyan: '#87e8de',
    gold: '#ffe58f',
    yellow: '#ffe58f',
    green: '#b7eb8f',
    red: '#ffa39e',
    volcano: '#ffbb96',
    orange: '#ffd591',
  };

  return colorMap[color];
};

/**
 * Returns the date difference from two give dates.
 * if the to is not defined it will default to current date
 * @param {string} from
 * @param {string} to
 * @returns {number}
 */
export const getDateDiff = (from: string, to?: string): number => {
  if (!from) return 0;
  const date1: any = new Date(from.replaceAll('-', '/'));
  const date2: any = to ? new Date(to.replaceAll('-', '/')) : Date.now();
  const diffTime = Math.abs(date1 - date2);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

/**
 * Converts the HTML List to string.
 * @param {string} data
 * @returns {string}
 */
export const convertHtmlListToText = (data: string): string => {
  data = data.replace('<ul>', '');
  data = data.replace('</ul>', '');
  data = data.replace('<li>', '');
  data = data.replaceAll('</li>', '');
  data = data.replaceAll('<li>', '\n');
  return data;
};

/**
 * return the month name for the give month in number
 * @param {number} monthNum
 * @returns {string}
 */
export const getMonthNameFromNumber = (value: number): string => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  return months[value - 1];
};

/**
 * coverts the Text to HTML List
 * @param {string} data
 * @returns {string}
 */
export const convertTextToHtmlList = (data: string) => {
  const lines = data.split('\n');
  let html = '<ul>';
  lines.forEach((line) => {
    html += `<li>${line}</li>`;
  });
  html += '</ul>';
  return html;
};

/**
 * Returns the random ANTD color
 * @returns {string}
 */
export const getRandomAntdTagColor = () => randomArrayItem(['cyan', 'purple', 'orange', 'geekblue', 'lime', 'magenta']);

export const parseDateToMMMDD = (date: any, utc = false, includeTh = false) => {
  if (!date) {
    return undefined;
  }

  const dateObj = utc ? dayjs.utc(date) : dayjs(date);

  let formatStr: string;

  if (dateObj.isSame(dayjs(), 'year')) {
    formatStr = includeTh ? 'MMM DD[th]' : 'MMM DD';
  } else {
    formatStr = 'MMM DD, YY';
  }

  return dateObj.format(formatStr);
};

/**
 * Converts any date format to US Date Format
 */
export const formatSimpleDate = (date?: string | null) => {
  if (!date) return '';
  const d = dayjs.utc(date);
  return d.isValid() ? d.format('YYYY-MM-DD') : '';
};

export const parseDateToUSFormat = (date: any, time = false, utc = false) => {
  if (!date) {
    return '-';
  }

  return (utc ? dayjs.utc(date) : dayjs(date)).format(`MM/DD/YYYY${time ? ' - hh:mm A' : ''}`);
};

export const formatCommentCreatedAt = (date: any, utc = false) => {
  if (!date) {
    return '-';
  }

  return (utc ? dayjs.utc(date) : dayjs(date)).format('[At] MMM DD, h:mm A');
};

/**
 * Formats completed_at with timezone comparison to date field
 * Renders in red if completed_at date differs from timelog date (both in America/New_York timezone)
 */
export const formatCompletedAtColumn = (completedAt: string, timelogDate: string): React.ReactNode => {
  if (!completedAt) return '-';
  const completedDay = dayjs(completedAt).tz('America/New_York').format('YYYY-MM-DD');
  const isDifferentDay = completedDay !== timelogDate;
  const formatted = parseDateToUSFormat(completedAt, true);
  if (isDifferentDay) {
    return React.createElement('span', { style: { color: '#CC0000' } }, formatted);
  }
  return formatted;
};

export const parseDate = (date: any, useUtc = false) => {
  if (!date) return '-';

  const parsed = useUtc ? dayjs.utc(date) : dayjs(date);
  return parsed.format('MM/DD/YYYY - hh:mm A');
};

export const parseDateNumberToTimeFormat = (days: number, hours: number, minutes: number) => {
  const totalHours = days * 24 + hours;

  return `${totalHours < 10 ? '0' : ''}${totalHours}:${minutes < 10 ? '0' : ''}${minutes}`;
};

export const getUserInitials = (user?: { name: string }): string | null => {
  if (!user?.name || user.name.trim() === '') {
    return null;
  }

  const nameArr = user.name.trim().split(/\s+/);

  if (nameArr.length >= 2) {
    const firstNameInitial = nameArr[0].charAt(0).toUpperCase();
    const lastNameInitial = nameArr[nameArr.length - 1].charAt(0).toUpperCase();

    return `${firstNameInitial}${lastNameInitial}`;
  }

  if (nameArr.length === 1) {
    const name = nameArr[0].toUpperCase();
    if (name.length >= 2) {
      return name.substring(0, 2);
    }
    return `${name.charAt(0)}${name.charAt(0)}`;
  }

  return null;
};

export function generateColor(string: string) {
  let hash = 0;

  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colorInt = hash & 0x00ffffff;

  const hex = colorInt.toString(16);

  return '#' + hex.padStart(6, '0');
}

export const getMentionUuidFromNode = (markup: string): string[] => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(markup, 'text/html');
  const uuids: string[] = [];

  doc.querySelectorAll<HTMLSpanElement>('span.mention').forEach((item) => {
    if (item.innerText.trim() && item.dataset.id) {
      uuids.push(item.dataset.id as string);
    }
  });

  return uuids;
};

export const mentionCommentParser = (comment: string): string => {
  const regex = /@\[(.*?)\]\(.*?\)/g;
  return comment.replaceAll(regex ?? '', '<span>@$1</span>');
};

export const deltaToHtml = (deltaString: string): string => {
  if (typeof document === 'undefined') return '';

  let delta;
  try {
    delta = JSON.parse(deltaString);
  } catch {
    return deltaString;
  }

  if (!delta || !Array.isArray(delta.ops)) return deltaString;

  const container = document.createElement('div');

  try {
    const quill = new Quill(container);
    quill.setContents(delta);
    return quill.root.innerHTML;
  } catch (error) {
    console.error(error);
    return '';
  }
};

export const getDateDifferenceInMinutes = (startDate: string, endDate = new Date(Date.now())): number => {
  return dayjs.utc(endDate).diff(dayjs.utc(startDate)) / 60000;
};

export const getOffsetTimestamp = (mins: number): Date => {
  const offsetTime = new Date();
  offsetTime.setMinutes(offsetTime.getMinutes() + mins);

  return offsetTime;
};

export const formatSimpleTime = (minutes: number) => {
  const h = Math.floor(minutes / 60)
    .toString()
    .padStart(2, '0');
  const m = (minutes % 60).toString().padStart(2, '0');
  return `${h}:${m}h`;
};

export const convertDaysHrsMinsToMins = (d: number, h: number, m: number): number => d * 24 * 60 + h * 60 + m;

export const convertMinsToHrsMins = (mins: number): string => {
  const isNegative = mins < 0;
  const positiveMins = isNegative ? mins * -1 : mins;

  const h = Math.floor(positiveMins / 60);
  const m = Math.floor(positiveMins % 60);

  const hStr = `${isNegative ? '-' : ''}${h < 10 ? `0${h}` : h}`;
  const mStr = m < 10 ? `0${m}` : m;
  return `${hStr}:${mStr}`;
};

export const convertMinsToHrsMinsSecs = (mins: number): string => {
  const isNegative = mins < 0;
  const totalSeconds = Math.floor(Math.abs(mins) * 60);

  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  const pad = (value: number) => (value < 10 ? `0${value}` : `${value}`);

  return `${isNegative ? '-' : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
};

export const convertHrsMinsToMins = (time: string): number => {
  const values = time.split(':');
  return parseInt(values[0], 10) * 60 + parseInt(values[1], 10);
};

export const formatTimeHM = (minutes: number | string): string => {
  if (typeof minutes === 'string') {
    minutes = convertHrsMinsToMins(minutes);
  }

  const isNegative = minutes < 0;
  const absMinutes = Math.abs(minutes);

  const h = Math.floor(absMinutes / 60);
  const m = absMinutes % 60;

  let formatted: string;

  if (absMinutes === 0) {
    formatted = '0h';
  } else if (m === 0) {
    formatted = `${h}h`;
  } else if (h === 0) {
    formatted = `0:${m.toString().padStart(2, '0')}h`;
  } else {
    formatted = `${h}:${m.toString().padStart(2, '0')}h`;
  }

  return isNegative ? `-${formatted}` : formatted;
};

export const getResponseTimeColor = (averageMinutes?: number | null): string | null => {
  if (!averageMinutes) return null;

  const THRESHOLD_2H = 120;
  const THRESHOLD_10H = 600;

  if (averageMinutes > THRESHOLD_10H) {
    return '#CC0000';
  }
  if (averageMinutes > THRESHOLD_2H) {
    return '#F9A825';
  }

  return null;
};

export const formatEstimateRange = (min: number, max: number): string => {
  if (!min && !max) {
    return 'No estimate';
  }

  const formatTime = (minutes: number) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m === 0 ? `${h}` : `${h}:${m.toString().padStart(2, '0')}`;
  };

  return `${formatTime(min)}-${formatTime(max)}h`;
};

export const renderTime = (time: string) => {
  return `${time} h`;
};

export const convertDaysHrsMinsSecsToHMS = (d: number, h: number, m: number, s: number): string => {
  const totalHours = d * 24 + h;
  const hStr = totalHours < 10 ? `0${totalHours}` : totalHours;
  const mStr = m < 10 ? `0${m}` : m;
  const sStr = s < 10 ? `0${s}` : s;
  return `${hStr}:${mStr}:${sStr}`;
};

/**
 * Return the query string value from the URL
 * @param {string} search
 * @param {string} key
 * @returns {string}
 */
export const getQueryValue = (search: string, key: string) => {
  const query = new URLSearchParams(search);
  return query.get(key);
};

export const ellipseText = (text: string | undefined | null, charsLimit = 50): string => {
  return text && text?.length > charsLimit ? `${text.substring(0, charsLimit)}...` : text ?? '';
};

export const convertArrToCommaSeparatedString = (array: any[]): string => {
  let finalString = '';

  array?.forEach((el: any, i: any) => {
    finalString += `${el}${i === array?.length - 1 ? '' : ', '}`;
  });

  return finalString;
};

export const minCharSpan = (text: string | any, minChars: number) => {
  if (!text) {
    text = '';
  }
  text = text?.toString();

  let finalText = '';

  const reqSpace = minChars - text?.length;

  if (reqSpace > 0) {
    Array(reqSpace)
      .fill(0)
      .forEach(() => {
        finalText += '&nbsp;';
      });
  }

  return finalText;
};

export const getHtmlFromArray = (value: any[]) => {
  let html = '<div>';
  value?.forEach((el) => {
    html += el;
  });
  html += '</div>';

  return html;
};

export const convertToSlug = (Text: string) => {
  if (!Text) return '';
  return Text.toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

export const trimUrl = (url?: string | undefined) => {
  if (!url) return null;

  if (url.slice(-1) === '/') {
    url = url.slice(0, -1);
  }

  return url;
};

export const checkIsEmail = (email: any) => {
  if (!email) return false;
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

const getHashOfString = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  hash = Math.abs(hash);
  return hash;
};

const normalizeHash = (hash: number, min: number, max: number) => {
  return Math.floor((hash % (max - min)) + min);
};

const hRange = [0, 360];
const sRange = [90, 100];
const lRange = [30, 50];

export const generateHexColor = (name: string) => {
  const hash = getHashOfString(name);
  const h = normalizeHash(hash, hRange[0], hRange[1]);
  const s = normalizeHash(hash, sRange[0], sRange[1]);
  const l = normalizeHash(hash, lRange[0], lRange[1]);
  return hslToHex(h, s, l);
};

function hslToHex(h: any, s: any, l: any) {
  h /= 360;
  s /= 100;
  l /= 100;
  let r, g, b;
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p: any, q: any, t: any) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  const toHex = (x: any) => {
    const hex = Math.round(x * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export const isSameDay = (d1: Date, d2: Date) => {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
};

export const normalizeURL = (url: string | undefined | null) => {
  if (!url) return undefined;

  return url.startsWith('www.') ? `https://${url}` : url;
};

export const includesInObject = (value: string, object: any) => {
  if (!object || !value) {
    return false;
  }

  let hasSearch = false;

  Object.keys(object).forEach((key: string) => {
    if (typeof object[key] === 'string') {
      if (object[key]?.toLowerCase().includes(value.toLowerCase())) {
        hasSearch = true;
      }
    } else if (typeof object[key] === 'object') {
      return includesInObject(value, object[key]);
    }
  });

  return hasSearch;
};

export const parseProjectTitle = (project: any) => {
  if (project?.kind === 'personal' || project?.project_kind === 'personal') {
    return project?.project_title ?? project?.title;
  }

  if (project?.project_title) {
    return `${project?.title}`;
  }

  return `${project?.title}`;
};

export const parseTaskTitle = (task: any) => {
  if (task?.project?.kind === 'personal' || task?.project_kind === 'personal') {
    return task?.task_title ?? task?.title;
  }

  return task?.task_title;
};

export const removeImage = (html?: string | null | undefined, url?: string) => {
  if (!html) {
    return html;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.querySelector(`img[src="${url}"]`)?.parentElement?.remove();

  return doc.body.innerHTML;
};

export const checkExternalUrl = (urlString: string) => {
  const url = new URL(urlString);

  return window.location.hostname !== url.hostname;
};

export const getNameAbbrev = (fullName: string) => {
  const names = fullName.split(' ');
  return names.length > 1 ? `${names[0]} ${names[1].substring(0, 1)}.` : fullName;
};

export const generateGravatarUrl = (email?: string, options: { size?: number } = {}, external = false) => {
  if (!email) {
    return undefined;
  }

  if (!email.endsWith('@savageglobalent.com') && !external) {
    return undefined;
  }

  const config = {
    size: 60,
    defaultImage: '404',
    secure: false,
    ...options,
  };

  const emailHash = enc.Hex.stringify(MD5(email.trim().toLowerCase()));

  const baseUrl = config.secure ? 'https://secure.gravatar.com/avatar/' : 'http://www.gravatar.com/avatar/';
  let gravatarUrl = `${baseUrl}${emailHash}`;

  // Add query parameters
  const params = [];
  if (config.size) params.push(`s=${config.size}`);
  if (config.defaultImage) params.push(`d=${config.defaultImage}`);

  if (params.length > 0) {
    gravatarUrl += `?${params.join('&')}`;
  }

  return gravatarUrl;
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const parseTimeToMinutes = (time: string): number => {
  if (!time || typeof time !== 'string') return 0;

  const [hStr, mStr] = time.split(':');

  const hours = parseInt(hStr, 10) || 0;
  const minutes = parseInt(mStr, 10) || 0;

  return hours * 60 + minutes;
};

export const convertMinToRoundedHours = (minutes?: number | null): string => {
  if (!minutes) return '0';
  const value = minutes < 0 ? minutes * -1 : minutes;
  const hours = Math.ceil(value / 60);
  return `${minutes < 0 ? '-' : ''}${hours}`;
};

export const getDueDays = (date: any) => {
  if (!date) return '-';

  const today = dayjs().startOf('day');
  const dueDate = dayjs(date).startOf('day');

  const diffDays = dueDate.diff(today, 'day');

  if (diffDays === 0) return 'Due today';
  if (diffDays < 0) return `Overdue by ${Math.abs(diffDays)} days`;

  return `Due in ${diffDays} ${diffDays === 1 ? 'day' : 'days'}`;
};

export const computeDueDateFlags = (dueDate: dayjs.Dayjs | null, isCompleted: boolean) => {
  if (!dueDate) return { isOverdue: false, isWarning: false, isToday: false };
  const today = dayjs().startOf('day');
  const daysUntilDue = dueDate.diff(today, 'day');
  const isFriday = today.day() === 5;
  return {
    isOverdue: !isCompleted && dueDate.isBefore(today, 'day'),
    isWarning: !isCompleted && daysUntilDue <= 3 && daysUntilDue > 0,
    isToday: !isCompleted && (
      dueDate.isSame(today, 'day') ||
      (isFriday && (
        dueDate.isSame(today.add(1, 'day'), 'day') ||
        dueDate.isSame(today.add(2, 'day'), 'day')
      ))
    ),
  };
};

export const getDueDateInfo = (item: any) => {
  const targetDateStr = item.status === 'completed'
    ? item.completed_at
      ? parseDateToUSFormat(item.completed_at, false, true)
      : 'no completed date'
    : item.target_date
      ? parseDateToUSFormat(item.target_date, false, true)
      : 'no due date';

  const targetDateObj = dayjs(targetDateStr).startOf('day');

  if (!targetDateObj.isValid()) {
    return { dueDate: undefined, isOverdue: false, isWarning: false, isToday: false };
  }

  const dueDate = parseDateToMMMDD(targetDateStr, false, false);
  const { isOverdue, isWarning, isToday } = computeDueDateFlags(targetDateObj, !!item.completed_at);

  return { dueDate, isOverdue, isWarning, isToday };
};
